import { ICreateJournalEntryParams, ICreateJournalEntryRepositoryResponse } from "@/core/repositories/accounting";
import { gql, type TypedDocumentNode } from "@apollo/client";

const CREATE_JOURNAL_ENTRY: TypedDocumentNode<
  ICreateJournalEntryRepositoryResponse,
  { params: ICreateJournalEntryParams }
> = gql`
  mutation CreateJournalEntry($params: CreateJournalEntryInput!) {
    createJournalEntry(params: $params) {
      status
      remittanceId
      checkNumber
      journalEntryId
      journalEntryDocNumber
      journalEntryDate
      totalAmt
      error
      msg
      msgId
      operationBatchId
    }
  }
`;

export default CREATE_JOURNAL_ENTRY;

